import TEST_VARIANTS from './variants.json';

export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST:
        'HA_PTA_LANDING_SLPTopXBestMetaTitleTrafficTest',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display_v2',
    MAP_PROPERTIES_REDESIGN_MOBILE:
        'HA_PTA_LANDING_MapPropertiesRedesignMobile',
    MAP_PROPERTIES_REDESIGN_DESKTOP:
        'HA_PTA_LANDING_MapPropertiesRedesignDesktop',
    SEARCH_FORM_SLP: 'HA_PTA_SEARCHFORM_SLP_V2',
    SEARCH_FORM_MLP: 'HA_PTA_SEARCHFORM_MLP_V2',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    DYNAMIC_SEO_INTRO_PARAGRAPH: 'HA_PTA_LANDING_SLPDynamicIntroParagraph',
    DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS:
        'VRBO_Landing_SLPDynamicIntroParagraphOtherPOS',
    DYNAMIC_RENDERING_2: 'HA_PTA_LANDING_DynamicRenderingIteration2',
    FAMILY_FRIENDLY_MODE: 'HA_PTA_LANDING_SLPFamilyFriendlyListings',
    PILL_FILTER_DESIGN: 'HA_PTA_Landing_Filterdesign',
    DESTINATION_REFINEMENTS_SLP_DESKTOP:
        'HA_PTA_LANDING_DynamicRefinementsSLPDesktop',
    DESTINATION_REFINEMENTS_SLP_MOBILE_TABLET:
        'HA_PTA_LANDING_DynamicRefinementsSLPMobileTablet',
    DESTINATION_REFINEMENTS_ITERATION_2:
        'VRBO_LANDING_Dynamicrefinementsdesktopiteration2',
    NO_GEO_FENCE_SEARCH_HISTORY: 'HA_PTA_LANDING_NoGeoFenceSearchHistorySLP',
    SERVER_SIDE_REVIEWS: 'HA_PTA_LANDING_SLPServerSideReviews',
    SERVER_SIDE_REVIEWS_TRAFFIC:
        'HA_PTA_LANDING_SLPServerSideReviewsTrafficTest',
    SEARCH_FORM_SLP_DATE_PICKER_OPENED:
        'HA_PTA_SEARCHFORM_SLP_Datepickeropened',
    HA_PTA_LANDING_SLP_H2_HEADINGS: 'HA_PTA_LANDING_SLPH2Headings',
    HA_PTA_LANDING_COVID19_ON_SLP: 'HA_PTA_LANDING_COVID19onSLP',
    HA_PTA_MLP_STAYCATION_BLACKLIST:
        'HA_PTA_MLP_BlacklistDestinationsStaycation',
    HA_PTA_LANDING_SLPHEROMAB: 'HA_PTA_LANDING_SLPHEROMAB', // 36217
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES:
        'HA_PTA_SEARCHBOX_hintTextChoosingDates', // 36021
    VRBO_LANDING_NEW_LISTINGS_API_FEATURE_GATE:
        'VRBO_LANDING_NewListingsAPIFeatureGate',
    SLP_FREE_CANCELLATION_CAROUSEL:
        'HA_PTA_Landing_SLPFreeCancellationCarousel',
    VRBO_LANDING_SLP_POI_ON_MAP: 'Vrbo_landing_SLPPOIONMAP',
    HEADING_CONVERSION: 'VRBO_LANDING_SLPHeadingConversionTestTemplate',
    HEADING_TRAFFIC: 'VRBO_LANDING_SLPHeadingTrafficTestTemplate',
    CONTENT_HUB_SLP: 'HA_PTA_LANDING_SLPContentHub',
    CONTENT_HUB_SLP_TRAFFIC: 'VRBO_LANDING_SLPContentHubTrafficTest',
    VRBO_WEB_GLOBAL_MESSAGING_BANNER: 'vrbo_web_global_messaging_banner',
    VRBO_WEB_GLOBAL_MESSAGING_ALERT: 'vrbo_web_global_messaging_alert', // 38174
    HA_PTA_SEARCHBOX_AddBedroomFilter: 'HA_PTA_SEARCHBOX_AddBedroomFilter', // 36212
    HA_TRAVELER_HEADER_TRAY_MOBILE_APP: 'HA_TRAVELER_HEADER_TRAY_MOBILE_APP',
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.POLYFILL_SERVICE,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_LID_SEARCH,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.MAP_PROPERTIES_REDESIGN_MOBILE,
    TESTS.MAP_PROPERTIES_REDESIGN_DESKTOP,
    TESTS.SEARCH_FORM_SLP,
    TESTS.SEARCH_FORM_MLP,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.HA_PTA_HEADER_LOGIN_COPY,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH_OTHER_POS,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.FAMILY_FRIENDLY_MODE,
    TESTS.PILL_FILTER_DESIGN,
    TESTS.DESTINATION_REFINEMENTS_SLP_DESKTOP,
    TESTS.DESTINATION_REFINEMENTS_SLP_MOBILE_TABLET,
    TESTS.DESTINATION_REFINEMENTS_ITERATION_2,
    TESTS.NO_GEO_FENCE_SEARCH_HISTORY,
    TESTS.SEARCH_FORM_SLP_DATE_PICKER_OPENED,
    TESTS.HA_PTA_LANDING_SLP_H2_HEADINGS,
    TESTS.HA_PTA_LANDING_COVID19_ON_SLP,
    TESTS.HA_PTA_MLP_STAYCATION_BLACKLIST,
    TESTS.HA_PTA_LANDING_SLPHEROMAB,
    TESTS.HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
    TESTS.VRBO_LANDING_NEW_LISTINGS_API_FEATURE_GATE,
    TESTS.SLP_FREE_CANCELLATION_CAROUSEL,
    TESTS.VRBO_LANDING_SLP_POI_ON_MAP,
    TESTS.HEADING_CONVERSION,
    TESTS.CONTENT_HUB_SLP,
    TESTS.CONTENT_HUB_SLP_TRAFFIC,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_ALERT,
    TESTS.HA_PTA_SEARCHBOX_AddBedroomFilter,
    TESTS.HA_TRAVELER_HEADER_TRAY_MOBILE_APP,
    TESTS.SERVER_SIDE_REVIEWS,
    TESTS.SERVER_SIDE_REVIEWS_TRAFFIC,
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    const testExists = hasTest(abacus, test);
    if (!testExists) {
        console.warn(`requested value for non-existent test: ${test}`); // eslint-disable-line no-console
    }
    return testExists ? abacus[test].value : null;
};

function withValueFrom(coll, key, op) {
    if (coll.hasOwnProperty(key)) {
        const v = coll[key];
        if (v !== null) {
            return op(v);
        }
    }
    return null;
}

export const getVariant = (abacus, testName) =>
    withValueFrom(TEST_VARIANTS, testName, (testData) =>
        withValueFrom(abacus, testData.key, (abData) =>
            withValueFrom(testData.variants, abData.value, (x) => x)
        )
    );
